import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile } from "../../../@css-style";

export const ElBanner = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 3em 0;
  background: linear-gradient(180deg, #e9f5ff 700%, rgba(229, 239, 255, 0.26) 83.7%, rgba(229, 239, 255, 0) 700%);
  /* background-repeat: no-repeat; */
  background-size: cover;
  ${String(isMobile)} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElBannerContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  padding: 10px;
  align-items: center;
  justify-content: space-between;
  position: relative;
  ${String(isMobile)} {
    width: 100% !important;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: none !important;
  }
`;

export const ElColumnSubs = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  max-width: 50%;
  position: relative;
  z-index: 2;
  width: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  line-height: 150%;
  gap: 20px;
  h3 {
    font-size: 24px;
    display: block;
    width: 100%;
    /* color: #ffffff; */
    font-weight: 400;
    ${String(isMobile)} {
      font-size: 16px;
    }
  }
  ${String(isMobile)} {
    max-width: 100% !important;
    flex: none !important;
    justify-content: center;
    align-items: center;
    * {
      text-align: center;
    }
  }
`;

export const ElBannerImageMain = styled.img`
  max-width: 100%;
  height: auto;
  width: 100% !important;
  /* position: absolute; */
  right: 0;
  min-height: 10px;
  width: 3px;
  /* background-color: #fff; */
  /* top: 0; */
`;

export const ElBannerImageCircle = styled.img`
  max-width: 100%;
  height: auto;
  left: 0;
  width: 100% !important;
  position: absolute;
  min-height: 10px;
  width: 500px !important;
  height: 500px;
  rotate: 180deg;
  top: -53%;
  left: -9%;
  opacity: 0.4;
  /* background-color: #fff; */
  /* top: 0; */
`;

export const elGapBanner = css`
  gap: 20px;
`;

export const elAnchorButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-main-flat-color);
  border: 1px solid var(--theme-main-green-color);
  background-color: var(--theme-main-green-color);
  transition: all 0.4s ease;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  padding: 12px 24px;
  border-radius: 3px;
  font-size: 14px;
  ${String(isMobile)} {
    padding: 8px 12px;
    font-size: 12px;
  }
  &:hover {
    color: var(--theme-main-green-color);
    background-color: var(--theme-main-flat-color);
  }
`;

export const elAnchorButtonWhite = css`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--theme-main-green-color);
  border: 1px solid var(--theme-main-green-color);
  background-color: var(--theme-main-flat-color);
  transition: all 0.4s ease;
  font-size: 14px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
  padding: 12px 24px;
  border-radius: 3px;
  ${String(isMobile)} {
    padding: 8px 12px;
    font-size: 12px;
  }
  &:hover {
    color: var(--theme-main-flat-color);
    background-color: var(--theme-main-green-color);
  }
`;
